import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/lucide_x.d7f63b4d.svg'
import _imports_1 from '../assets/image_195.85646f1a.svg'


const _hoisted_1 = {
  key: 0,
  class: "dynamic-component"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "end_box code_box" }
const _hoisted_4 = { class: "time_tip" }
const _hoisted_5 = { class: "time" }

import { onBeforeUnmount, onMounted, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'unpaid',
  setup(__props) {

const targetTimestamp = ref(0);

const isActive = ref(true);
const remainingTime = ref(targetTimestamp.value - new Date().getTime());
const countdown = ref("");

function formatTime(ms: number): string {
  const seconds = String(Math.floor(ms / 1000) % 60).padStart(2, "0");
  const minutes = String(Math.floor(ms / (1000 * 60)) % 60).padStart(2, "0");
  const hours = String(Math.floor(ms / (1000 * 60 * 60)) % 24).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
}

function updateCountdown() {
  remainingTime.value = targetTimestamp.value - new Date().getTime();
  if (remainingTime.value <= 0) {
    countdown.value = "倒计时结束！";
    isActive.value = false;
  } else {
    countdown.value = formatTime(remainingTime.value);
  }
}

let interval: ReturnType<typeof setInterval>;

onMounted(() => {
  interval = setInterval(updateCountdown, 1000);
  targetTimestamp.value = Number(localStorage.getItem("expirationTimestamp"));

  updateCountdown();
});

onBeforeUnmount(() => {
  clearInterval(interval);
});

return (_ctx: any,_cache: any) => {
  return (isActive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isActive.value = !isActive.value))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("div", {
              class: "img",
              style: {"width":"50%"}
            }, [
              _createElementVNode("img", {
                alt: "",
                src: _imports_1
              })
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createTextVNode(" 剩余时间:")),
              _createElementVNode("span", _hoisted_5, _toDisplayString(countdown.value), 1)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "end_tip" }, "订单尚未完成", -1))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})